import { Api } from '@monorepo/shared/apiClient';
import { MutationConfig, useMutation } from 'react-query';

type UseReassignTasksParams = {
  config?: MutationConfig<void, Api.ErrorResponse, Api.ReassignTasksParams>;
};

export function useReassignTasks(params?: UseReassignTasksParams) {
  return useMutation(Api.reassignTasks, {
    ...params?.config,
    // allow the queue commands to clear the cache, don't clear it here
    onSuccess: (data, variables) =>
      params?.config?.onSuccess?.(data, variables),
    onError: (error, variables, rollback) =>
      params?.config?.onError?.(error, variables, rollback),
  });
}
